// extracted by mini-css-extract-plugin
module.exports = {"dmsWrapper":"DMSWidget_dmsWrapper__HN7Xw","imageWrapper":"DMSWidget_imageWrapper__xl2dT","button":"DMSWidget_button__yWVQq"};